import { Component, input, OnInit, output } from '@angular/core'
import { ColorPickerComponent, PickerColor } from '@shared/color-picker/color-picker.component'
import { SetType } from '@shared/models/picker'
import { Field } from '@models/ui'
import { parseConfigureJson } from '@app/feature/add-field/add-field-content/add-field-content-common'
import { IconPickerComponent, PickerIcon } from '@shared/icon-picker/icon-picker.component'
import { TbSelectComponent } from '@components-library/tb-select/components/tb-select/tb-select.component'
import { TbOptionComponent } from '@components-library/tb-select/components/tb-option/tb-option.component'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TranslocoDirective } from '@jsverse/transloco'

export interface RatingCellSettings {
    color: string
    icon: string
    count: number
}

@Component({
    selector: 'app-rating-cell-settings',
    imports: [
        ColorPickerComponent,
        IconPickerComponent,
        TbSelectComponent,
        TbOptionComponent,
        TbIconComponent,
        TranslocoDirective,
    ],
    templateUrl: './rating-cell-settings.component.html',
})
export class RatingCellSettingsComponent implements OnInit {
    protected readonly SetType = SetType

    field = input.required<Field>()

    configurationChanged = output<RatingCellSettings>()

    settings: RatingCellSettings = {
        color: '',
        icon: '',
        count: 5,
    }

    protected countArray = this.generateCountArray(5)
    protected previewCountArray = this.generateCountArray(this.settings.count)

    ngOnInit() {
        const parsedJson = parseConfigureJson<RatingCellSettings>(this.field().configure_json)

        if (parsedJson) {
            this.settings = parsedJson
            this.previewCountArray = this.generateCountArray(this.settings.count)
        }
    }

    updateColor(color: PickerColor) {
        this.settings.color = color.color
        this.updateValue()
    }

    updateIcon(icon: PickerIcon) {
        this.settings.icon = icon.icon!
        this.updateValue()
    }

    updateCount(count: number) {
        this.settings.count = count
        this.previewCountArray = this.generateCountArray(this.settings.count)
        this.updateValue()
    }

    private updateValue(): void {
        this.configurationChanged.emit({ ...this.settings })
    }

    private generateCountArray(length: number): number[] {
        return Array.from({ length }, (_, i) => i + 1)
    }
}
